// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__16DsR","cell":"ColumnAccessor_cell__1YiBA","firstCellAccent":"ColumnAccessor_firstCellAccent__1uh90"};